import { useCallback, useState } from 'react';
import { formatOrderNumbers } from '../contexts/zod';
import { tCarrierItem } from '../contexts/zod/types';
import { useApi } from './useApi';

 const useCarrier = () => {
  const api = useApi();
  const [carriers, setCarriers] = useState<tCarrierItem[] | undefined>();
  const [loading, setLoading] = useState(false);

  const getCarriers = useCallback(async (orderNumbers: string[]) => {
    setLoading(true);
    const response = await api(
      `carriers?${formatOrderNumbers(orderNumbers)}`,
      'GET',
      '*',
    );
    setCarriers(response.data.carrierServices);
    setLoading(false);
  }, [api]);

  return { carriers, loading, getCarriers };
};

export default useCarrier;
